<cbc-container [isLoading]="isLoading" [showContainer]="!isLoading" title="Ofertas de Exames e Terapias">
</cbc-container>
@if(!isLoading) {
<div class="container" [class.is_mobile]="isMobile">

  <!-- Lista de Ofertas -->
  <section class="mb-xl">
    @for(resourceOffering of resourceOfferingProviderPJList; track trackById($index, resourceOffering)) {
    <div class="card mb-lg">

      <!-- Card Header -->
      <div class="card-header">
        <div class="offer-header">
          <div>
            <div class="title-secondary">Oferta #{{ resourceOffering.id }}</div>
            <div class="title-secondary-description">
              {{ getResourcesDescription(resourceOffering.resource) }}
            </div>
          </div>
          <span class="badge badge-primary">
            {{ resourceOffering.status! | enumDescription }}
          </span>
        </div>

        <div class="offer-dates mt-md">
          @if(resourceOffering.publicationDate) {
          <span class="badge badge-success">
            Publicado em {{ resourceOffering.publicationDate | date:"dd/MM/yyyy" }}
          </span>
          @if(resourceOffering.expirationPublicationDate) {
          <span class="badge badge-warning">
            Válido até {{ resourceOffering.expirationPublicationDate | date:"dd/MM/yyyy" }}
          </span>
          }
          } @else {
          <span class="badge badge-warning">Não Publicado</span>
          }
        </div>
      </div>

      <!-- Card Body -->
      <div class="card-body">

        <!-- Recursos Agrupados -->
        <ng-container *ngIf="getResourceGroups(resourceOffering.resource) as groups">

          @if(groups.exames.length > 0) {
          <div class="mb-md">
            <div class="section-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="var(--color-primary)"
                viewBox="0 0 256 256">
                <path
                  d="M200,136H152V88a24,24,0,0,0-48,0v48H56a24,24,0,0,0,0,48H104v24a24,24,0,0,0,48,0V184h48a24,24,0,0,0,0-48Z"
                  opacity="0.2" />
                <path
                  d="M200,128H136V64a8,8,0,0,0-16,0v64H56a8,8,0,0,0,0,16h64v64a8,8,0,0,0,16,0V144h64a8,8,0,0,0,0-16Z" />
              </svg>
              Exames
            </div>
            <div class="resource-tags">
              @for(exame of groups.exames; track exame.key) {
              <span class="badge badge-primary">{{ exame.description }}</span>
              }
            </div>
          </div>
          }

          @if(groups.terapias.length > 0) {
          <div class="mb-md">
            <div class="section-label">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="var(--color-primary)"
                viewBox="0 0 256 256">
                <path d="M224,128a96,96,0,1,1-96-96A96,96,0,0,1,224,128Z" opacity="0.2" />
                <path
                  d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z" />
              </svg>
              Terapias
            </div>
            <div class="resource-tags">
              @for(terapia of groups.terapias; track terapia.key) {
              <span class="badge badge-success">{{ terapia.description }}</span>
              }
            </div>
          </div>
          }

        </ng-container>

        <!-- Informações -->
        <div class="info-row mb-sm">
          <span class="info-label">Criado em</span>
          <span class="info-separator"></span>
          <strong class="info-data">{{ resourceOffering.creationDate | date:'dd/MM/yyyy - HH:mm' }}</strong>
        </div>

        @if(resourceOffering.address?.street) {
        <div class="info-row mb-sm">
          <span class="info-label">Endereço</span>
          <span class="info-separator"></span>
          <strong class="info-data">
            {{ resourceOffering.address?.street }}, {{ resourceOffering.address?.number }} —
            {{ resourceOffering.address?.city }}/{{ resourceOffering.address?.state }}
          </strong>
        </div>
        }

        <!-- Disponibilidade -->
        <div class="mt-md">
          <div class="section-label mb-sm">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="var(--color-primary)"
              viewBox="0 0 256 256">
              <path d="M216,48H40a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48Z"
                opacity="0.2" />
              <path
                d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z" />
            </svg>
            Disponibilidade
          </div>
          <app-availability [availabilityShow]="resourceOffering.availability"></app-availability>
        </div>
      </div>

      <!-- Card Footer -->
      <div class="card-footer">
        <div class="footerButtons">
          @if(!resourceOffering.publicationDate) {
          <button mat-flat-button color="primary" (click)="publish(resourceOffering.id!.toString())">
            <mat-icon>rocket_launch</mat-icon>
            Publicar
          </button>
          }
          <button mat-button [routerLink]="['resourceOfferingForm', resourceOffering.id]">
            <mat-icon>edit</mat-icon>
            Alterar
          </button>
          <button mat-button color="warn" (click)="deleteServiceOffering(resourceOffering.id!.toString())">
            <mat-icon>delete</mat-icon>
            Excluir
          </button>
        </div>
      </div>

    </div>
    }
  </section>

  <!-- Nova Oferta -->
  <section>
    <button mat-flat-button color="primary" [routerLink]="['resourceOfferingForm']"
      class="btn btn-primary btn-full-line">
      <mat-icon>add_circle</mat-icon>
      Criar nova oferta de exames e terapias
    </button>
  </section>

</div>
}